import { type EnvironmentId } from "@cmmd-forge/contracts";
import { useCallback } from "react";
import { readEnvironmentApi } from "../../environmentApi";
import { newCommandId } from "~/lib/utils";
import { type Thread } from "../../types";

export function useChatInterrupt(input: {
  readonly environmentId: EnvironmentId;
  readonly activeThread: Thread | undefined;
}): () => Promise<void> {
  return useCallback(async () => {
    const api = readEnvironmentApi(input.environmentId);
    if (!api || !input.activeThread) return;
    await api.orchestration.dispatchCommand({
      type: "thread.turn.interrupt",
      commandId: newCommandId(),
      threadId: input.activeThread.id,
      createdAt: new Date().toISOString(),
    });
  }, [input.activeThread, input.environmentId]);
}
